module.exports = __webpack_public_path__ + "img/stock6.13483d8e.png";